import { actionTypes } from '../../../types';

// Action creator for generating OTP request
export const getCountryByRegion = (payload) => ({
    type: actionTypes.GET_COUNTRY_BY_REGION_REQUEST,
    payload,
});

// Action creator for successful OTP generation
export const getCountryByRegionSuccess = (payload) => ({
    type: actionTypes.GET_COUNTRY_BY_REGION_SUCCESS,
    payload,
});

// Action creator for failed OTP generation
export const getCountryByRegionFailure = (payload) => ({
    type: actionTypes.GET_COUNTRY_BY_REGION_FAILURE,
    payload,
});

// Action creator for resetting OTP generation status
export const getCountryByRegionReset = () => ({
    type: actionTypes.GET_COUNTRY_BY_REGION_RESET,
});

// Action creator for resetting all OTP generation reducer
export const getCountryByRegionResetAll = () => ({
    type: actionTypes.GET_COUNTRY_BY_REGION_RESET_ALL,
}); 